export const sort = [
  {
    label: "ID",
    name: "id",
    style: { width: 130 },
  },
  { label: "Nazwa", name: "identifier" },
  { label: "Label", name: "label", sortable: false },
  { label: "Sklep", name: "shop_id" },
  { label: "Platforma", name: "platform_id" },
];

export const filters = [
  {
    type: "input",
    name: "identifier",
    sort_id: "identifier",
    search_type: "matches",
  },
];
